import { render } from "./CustomerRepurchase.vue?vue&type=template&id=46a8aaf6"
import script from "./CustomerRepurchase.vue?vue&type=script&lang=js"
export * from "./CustomerRepurchase.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__